<template>
  <div class="ocr-message-container d-flex pa-5 rounded-lg">
    <app-material-icon
      class="mr-2"
      color="#2671F2"
      name="info"
    />
    <div class="w-100">
      <div class="text--small text--regular mb-0">
        <span class="font-weight-bold">
          {{ $t('common.PdfRedactingSidebar.ocrMessage.pdfContainsNoText') }}
        </span>

        <p class="mt-2">
          {{ $t('common.PdfRedactingSidebar.ocrMessage.ocrProcessExplanation') }}
          <a class="app-link learnMoreLink font-weight-medium" :href="learnMoreLink" target="_blank">
            {{ $t("common.learnMore") }}
          </a>
        </p>

        <app-button class="mt-4"
                    size="small"
                    fullWidth
                    type="outlined"
                    variant="neutral"
                    @click="$emit('launch-ocr-conversion')"
        >
          <app-material-icon name="cached" />
          {{ $t('common.PdfRedactingSidebar.ocrMessage.launchConversion') }}
        </app-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

defineEmits(['launch-ocr-conversion'])

const { t } = useI18n()

const learnMoreLink = computed(() => t('common.helpLinks.ocr'))
</script>

<style scoped lang="scss">
.ocr-message-container {
  background-color: rgb(var(--v-theme-info-lighten-5));
}

a.learnMoreLink {
  color: rgb(var(--v-theme-info-darken-1));
  text-decoration: underline;
}
</style>
